import { noChange } from 'lit';
import { directive, Directive } from 'lit/directive.js';
import { extractFunctionalElement } from './directive-util';
/**
 * The directive generics (in listenDirective) are not strong enough to maintain their values. Thus,
 * the directive call is wrapped in this function.
 */
export function assign(propertyDescriptor, value) {
    return assignDirective(propertyDescriptor.propName, value);
}
const assignDirective = directive(class extends Directive {
    constructor(partInfo) {
        super(partInfo);
        this.element = extractFunctionalElement(partInfo, 'assign');
    }
    render(propName, value) {
        if (!(propName in this.element.instanceProps)) {
            throw new Error(`${this.element.tagName} element has no property of name "${propName}"`);
        }
        this.element.instanceProps[propName] = value;
        return noChange;
    }
});
